import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";
import { alertActions } from "../../actions";
import { contentRef } from "../../firebase";
import { ContentStepper } from "../../components";
import {useLocation} from "react-router";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    fontFamily:'Bogart !important',
    marginTop: "90px",
  }
}));
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
export const HomePage = () => {
    const query = useLocation().search.substr(6);
    const [content, setContent] = useState(null);
    const dispatch = useDispatch();
    const classes = useStyles();

    useEffect(() => {
    contentRef.get()
      .then((snapshot) => {
        if (!snapshot.exists()) {
          setContent(null)
          return;
        }
        const data = snapshot.val();
        setContent(data.content);
      }, (error) => {
        setTimeout(() => {
        }, 5000);
      });
    },[dispatch])

    return (
        <div>
          <Container className={classes.root}>
            {content ? <ContentStepper content={content} query={query}/> : ""}
          </Container>
        </div>
    )
};
